import React, { useCallback, useEffect } from 'react';

import { useHistory } from 'react-router-dom';
import TabBar from './TabBar';

import { Container } from './styles';
import { useAuth } from '../../hooks/auth';
import Load from '../../newComponents/Load';
import { useToast } from '../../hooks/toast';

const Configuracoes: React.FC = () => {
  const { rotinas, findRotinas } = useAuth();
  const { addToast } = useToast();
  const history = useHistory();

  const hasPermission = useCallback(
    (): boolean => findRotinas('configuracoes')?.listar || false,
    [findRotinas],
  );

  useEffect(() => {
    if (rotinas && !hasPermission()) {
      addToast({
        type: 'error',
        title: 'Não autorizado.',
        description: 'Você não tem permissão.',
      });
      history.push('/monitor_pedidos');
    }
  }, [addToast, hasPermission, history, rotinas]);

  return (
    <>
      {rotinas ? (
        <Container>
          <header>
            <h1>Configurações</h1>
            <p>Edite suas informações e adicione funciários</p>
          </header>

          <TabBar />
        </Container>
      ) : (
        <div
          style={{
            display: 'flex',
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Load />
        </div>
      )}
    </>
  );
};

export default Configuracoes;
